import React from 'react';
import classnames from 'classnames';
import { DangerText } from 'scy/text';
import { textOverflow, valignMiddle, width100 } from 'scy/utils.mod.scss';
import { inlineBlock } from 'scy/display.mod.scss';
import { h4 } from 'scy/text/styles.mod.scss';
import { soldoutTitleContainer } from '../styles.mod.scss';

export default function Title({ soldout, title, includeItemProps }) {
  return (
    <div
      className={classnames(h4, textOverflow)}
      itemProp={includeItemProps ? 'name' : undefined}
    >
      <div
        className={classnames(
          textOverflow,
          inlineBlock,
          valignMiddle,
          width100,
          {
            [soldoutTitleContainer]: soldout
          }
        )}
      >
        {title}
      </div>
      {soldout && (
        <>
          {' '}
          <div className={classnames(inlineBlock, valignMiddle)}>
            | <DangerText tag="span">Sold Out</DangerText>
          </div>
        </>
      )}
    </div>
  );
}
